import { SituacaoSorteioModel } from './situacao-sorteio.model';
import { ResultadoLoteriaFederacaoModel } from './resultado-loteria-federal.model';
import { TipoSorteioModel } from './tipo-sorteio.model';

export class SorteioModel {
  public seqSorteioPremiacaoConsumidor: number;
  public desSorteioPremiacaoConsumidor: string;
  public codTipoSorteioPremiacaoConsumidor: number;
  public codSituacaoSorteioPremiacaoConsumidor: number;
  public dataPrevisaoSorteioPremiacaoConsumidor: Date;
  public dataRealizacaoSorteiroPremiacaoConsumidor?: Date;
  public dataExtracaoLoteriaFederal?: Date;
  public dataPublicacaoResultado?: Date;
  public desChaveSorteioPremiacaoConsumidor: string;
  public desAssinaturaDigitalArquivoPublicoParticipante: string;
  public desAssinaturaDigitalArquivoPrivadoParticipante: string;
  public dataInicioPeriodoBilhetesParticipantes?: Date;
  public dataFinalPeriodoBilhetesParticipantes?: Date;
  public nomArquivoPublicoParticipante: string;
  public nomArquivoPublicoResultadoSorteio: string;
  public nomArquivoPrivadoResultadoSorteio: string;
  public dataAtualizacao?: Date;
  public desAssinaturaDigitalArquivoPrivadoResultadoSorteio: string;
  public dataHomologacaoArquivoPublicoParticipante: Date;
  public dumSorteioPremiacaoConsumidor: number;
  public dtdTotalBilheteGerado?: number;

  public resultadoLoteriaFederal: ResultadoLoteriaFederacaoModel;
  public tipoSorteioPremiacaoConsumidor: TipoSorteioModel;
  public situacaoSorteioPremiacaoConsumidor: SituacaoSorteioModel;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/sorteio.model.ts